import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { DeviceService } from '@shared/services';
import { SortModel } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { SdvorSelectModule } from '../../select';

@Component({
  selector: 'sd-sorting',
  templateUrl: './custom-sorting.component.html',
  styleUrls: ['./custom-sorting.component.scss'],
  imports: [NgIf, AsyncPipe, NgFor, SdvorSelectModule, FormsModule, ReactiveFormsModule, IconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomSortingComponent implements OnChanges {
  iconType = CUSTOM_ICON_TYPE;
  @Input()
  sortOptions: SortModel[];
  @Input()
  selectedOption: string;
  @Input()
  placeholder: string;
  @Input()
  sortLabels: { [code: string]: string };

  @Output()
  sortListEvent: EventEmitter<string> = new EventEmitter<string>();

  get selectedLabel(): string {
    return (
      this.sortOptions?.find((sort) => sort.code === this.selectedOption)?.name ??
      this.sortLabels?.[this.selectedOption]
    );
  }

  constructor(public deviceService: DeviceService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sortOptions) {
      this.sortOptions = this.sortOptions?.filter(({ name, code }) => Boolean(name) || Boolean(this.sortLabels[code]));
    }
  }

  sortList(sort: string): void {
    this.sortListEvent.emit(sort);
  }
}
